import React, { Component } from "react";
import ProgressBarSquare             from "../../components/utils/ProgressBarSquare";
import "../../css/LoadingBar.css";

// Declare timer globally or the ClearInterval() won't work properly //
var timer;

export default class FooterLoadingBar extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showLoadingBar: props.showLoadingBar
        }
    }

    componentDidMount(){
        // do ont start timer upon initial load
    }

    componentWillReceiveProps (props) {

        var screen     = props.screen;
        var action     = props.action;
        var program_id = props.newProgramId;

        //console.log("Footer bar program_id: " + program_id);
        //console.log("Footer loading bar action: " + action);

        ////  IF the API Gateway times out, continue waiting until the duplicate program process has finished  ////
        if(action === "programList_duplicateProgram") {
                var secs = props.loadingTime;

                // Clear interval otherwise the counter will continue
                if(secs == null) clearInterval(timer);

                if(secs > 0 && secs != null) {
                    // console.log(".... 1. Begin timer ....");
                    timer = setInterval(startTimer, 1000);

                    function startTimer() {
                        //console.log("1. counting secs: "+ secs++);
                        // API Gateway closes connection after 30 secs  //
                        if(secs >= 28) {
                            clearInterval(timer)
                            //// If duplicating program data is taking too long, assign the task to the bkgrd header
                            props.showTaskManagerHeader();
                            ////  Hide the popup while the task is processing in the backgrund  ////
                            // temp remove 11.19/19
                            // props.clearProgressOverlay();
                            // console.log("------------ Only process callback once! ------------");
                            var start_timer = true;
                            props.processCallback(program_id, start_timer);
                        }
                    }
                }

                this.setState({ showLoadingBar: props.showLoadingBar })
        } else {
            this.setState({ showLoadingBar: props.showLoadingBar })
            clearInterval(timer); // stop timer above
        }
    }

    closeLoadingBar = () => {
        this.setState({
            showLoadingBar: "none"
        })
    }

    render() {

        return (
            <div className="loadingBarContainer" style={{display: this.state.showLoadingBar}}>
                <span style={{position:"fixed", top:"30%", marginLeft:"50%", left: -170, zIndex: 10000}}>
                        <ProgressBarSquare message={this.props.text}/>
                </span>
                <span className="loadingBarMessage">
                    { /*}<span className="glyphicon glyphicon-bullhorn"></span>
                &nbsp; {this.props.text} &nbsp;*/ }

                    <span className="pullRight"
                          onClick={() => this.closeLoadingBar()}
                          style={{position:"relative", float:"left", cursor:"pointer", color:"#999"}}>
                        &nbsp; &nbsp; <span className="glyphicon glyphicon-remove-circle"></span>
                        &nbsp;Cancel
                    </span>
                </span>
                <span className="loadingBarFooter"></span>
                <span className="loadingBarBackground"></span>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/utils/FooterLoadingBar.js